import { Popover } from '@mui/material';
import React from 'react';
import './ColorSwatchPicker.scss';

export const PRESET_COLORS = [
  // Row 1 — warm
  '#E8B4B8',
  '#F2C9A0',
  '#F0DFA0',
  '#D5E8A0',
  '#A8D8A8',
  '#8ED4CE',
  '#8EC8E0',
  '#A0BCE8',
  // Row 2 — cool
  '#B4A8E8',
  '#C8A0D8',
  '#D8A0C4',
  '#E8A0B4',
  '#D4B0A8',
  '#C8C0B0',
  '#B4C8C8',
  '#A8BCCF',
];

interface ColorSwatchPickerProps {
  anchorEl: HTMLElement | null;
  currentColor?: string | null;
  onColorSelect: (hex: string | null) => void;
  onClose: () => void;
}

function ColorSwatchPicker({
  anchorEl,
  currentColor,
  onColorSelect,
  onClose,
}: ColorSwatchPickerProps) {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        paper: { sx: { mt: 0.75, borderRadius: '10px', boxShadow: '0 4px 20px rgba(0,0,0,0.12)' } },
      }}
    >
      <div className='color-swatch-picker'>
        <div className='color-swatch-grid'>
          {PRESET_COLORS.map((hex) => (
            <button
              type='button'
              key={hex}
              className={`color-swatch${currentColor === hex ? ' selected' : ''}`}
              style={{ backgroundColor: hex }}
              onClick={() => {
                onColorSelect(hex);
                onClose();
              }}
              aria-label={`Select color ${hex}`}
            />
          ))}
        </div>
        <div className='color-swatch-none-row'>
          <button
            type='button'
            className={`color-swatch-none${!currentColor ? ' selected' : ''}`}
            onClick={() => {
              onColorSelect(null);
              onClose();
            }}
            aria-label='Clear color'
          />
          <span className='color-swatch-none-label'>None</span>
        </div>
      </div>
    </Popover>
  );
}

ColorSwatchPicker.displayName = 'ColorSwatchPicker';
export default ColorSwatchPicker;
